import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db, user } from '../../../../firebase';
import { collection, getDocs, where, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

import VisualDesign from './VisualDesign';
import PortfolioHeader from '../Header';
import LogoDesign from './LogoDesign';

const UIUX = () => {
  const [link, setLink] = useState('visualdesign');
  const [portfolioData, setPortfolioData] = useState([]);

  useEffect(() => {
    console.log(user);
    if (user) {
      fetchPortfolioData();
    }
  }, []);

  const fetchPortfolioData = async () => {
    const q = query(collection(db, 'portfolio'), where('project_type', 'array-contains', 'websitedesign'));
    const querySnapshot = await getDocs(q);
    console.log(querySnapshot);
    let data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      data: doc.data(),
    }));
    console.log(data);
    console.log(data[0].data['project_pilot_screenshots'].sort());
    console.log(data[0].data['project_full_screenshots'].sort());
    data.forEach((item) => {
      item.data['project_pilot_screenshots'].sort();
      item.data['project_full_screenshots'].sort();
    });

    setPortfolioData(data);
  };
  useEffect(() => {
    console.log(portfolioData);
  }, [portfolioData]);
  return (
    <>
      <PortfolioHeader />
      <div className='gearsBg'>
        <div className='wheel8'> </div>
        <div className='wheel9'> </div>
        <div className='wheel10'> </div>
        <ul className='innerTopNav'>
          <li>
            <Link to='/portfolio/frontend'>
              <span> Front - end Stack </span>
            </Link>
          </li>
          <li>
            <Link to='/portfolio/uiux' className='active'>
              <span> UI / UX </span>
            </Link>
          </li>
          <li>
            <Link to='/portfolio/middleware'>
              <span> Middleware </span>
            </Link>
          </li>
          <li>
            <Link to='/portfolio/digitalmarketing'>
              <span> Digital Marketing </span>
            </Link>
          </li>
        </ul>
      </div>
      <div className='paper'>
        <div className='top'> &nbsp; </div>
        <div className='mid clearfix'>
          <div className='leftnav'>
            <ul id='leftnav'>
              <li>
                <span
                  className={link === 'visualdesign' ? 'active' : ''}
                  onClick={() => {
                    setLink('visualdesign');
                  }}>
                  Visual Design
                </span>
              </li>
              <li>
                <span
                  className={link === 'logodesign' ? 'active' : ''}
                  onClick={() => {
                    setLink('logodesign');
                  }}>
                  Logo Design
                </span>
              </li>
              {/*  <li><span className={link === 'printdesign' ? 'active' : ''} onClick={() => { setLink('printdesign') }}>Print Design</span></li> */}
            </ul>
          </div>
          <div className='maincontent'>
            <div className='breadcrumb'>
              <Link to='/portfolio/home'> Home </Link> » UI/UX
            </div>
            {(() => {
              console.log();
              switch (link) {
                case 'visualdesign':
                  return <VisualDesign portfolioData={portfolioData} type={'vd'} />;
                case 'logodesign':
                  return <LogoDesign />;
                default:
                  return null;
              }
            })()}
          </div>
        </div>
        <div className='btm'> &nbsp; </div>{' '}
      </div>
    </>
  );
};
export default UIUX;